
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { ProcurementFormValues } from "../schema";

interface DamageReturnSectionProps {
  form: UseFormReturn<ProcurementFormValues>;
  supportsDamageReturn: boolean;
}

export const DamageReturnSection = ({ form, supportsDamageReturn }: DamageReturnSectionProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="supports_damage_return"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">Damage Return</FormLabel>
              <FormDescription>
                If enabled, allows for return of damaged goods
              </FormDescription>
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {supportsDamageReturn && (
        <FormField
          control={form.control}
          name="damage_return_percentage"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Return Percentage (%)</FormLabel>
              <FormDescription>
                Maximum percentage of goods that can be returned if damaged
              </FormDescription>
              <FormControl>
                <Input
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  {...field}
                  onChange={e => field.onChange(parseFloat(e.target.value) || 0)}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
};
